/* Publish by EComposer at 2026-09-30 10:16:44*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-edhp315y2s7"]=  window.__ectimmers["ecom-edhp315y2s7"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-edhp315y2s7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edhp315y2s7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w4gv8kqv38g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w4gv8kqv38g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0shijnal4gro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0shijnal4gro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zoztecxunzk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zoztecxunzk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g408fka6fqi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g408fka6fqi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6y9dfa1n6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6y9dfa1n6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mus4lw4waj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mus4lw4waj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g2gwoxpjfj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g2gwoxpjfj6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bkv0sjmdy6v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bkv0sjmdy6v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-abvjlljqcqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-abvjlljqcqh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g5qvbh73or').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g5qvbh73or', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-okfi4b87ulp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-okfi4b87ulp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a40978qg4n7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a40978qg4n7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9a98xcwrk0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9a98xcwrk0o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5odsaeg3gg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5odsaeg3gg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hqebgf8pb9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hqebgf8pb9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9zkim2mxtp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9zkim2mxtp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0vone212chg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0vone212chg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yh0b5pdc24p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yh0b5pdc24p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmsprgh434').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmsprgh434', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cjyu2f4bmiu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjyu2f4bmiu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tc8dkdyrtf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tc8dkdyrtf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mjuv8rttqt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mjuv8rttqt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ysh5bhlkv5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ysh5bhlkv5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-on01ryy2bfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-on01ryy2bfo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r9qhq4oy9ph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r9qhq4oy9ph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-851wtyj7t2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-851wtyj7t2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qrjlpjcnjjr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qrjlpjcnjjr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z3k9jtip6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z3k9jtip6h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pymixndv5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pymixndv5i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9exkjbvb9dv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9exkjbvb9dv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aw46286nwkc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aw46286nwkc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ryhqrwyduv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ryhqrwyduv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3fkqt7y3d3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fkqt7y3d3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cik513jabnj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cik513jabnj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4eww2dswoh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4eww2dswoh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r5u0rd4o4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r5u0rd4o4f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u6gu8580xlb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u6gu8580xlb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewhfwltx2ik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewhfwltx2ik', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12lh3b9o106').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12lh3b9o106', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0k9vzx6m9x3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0k9vzx6m9x3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qr9mq7zdqzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qr9mq7zdqzo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ogxf6n5asr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ogxf6n5asr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k011mahq7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k011mahq7k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ht27f2ygpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ht27f2ygpj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0l30h05wgbjm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0l30h05wgbjm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-swjbxpnifuh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-swjbxpnifuh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36ogzyumtgz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36ogzyumtgz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yk172iktf7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yk172iktf7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-koxb06ohpq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-koxb06ohpq8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3hzhpy7cv4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hzhpy7cv4b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-79q9uvfp7mo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79q9uvfp7mo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7dtodmhnob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7dtodmhnob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t4zv03nd37h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4zv03nd37h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jsk3k81tsod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jsk3k81tsod', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gimef2r5iy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gimef2r5iy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oi3hgct9uai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oi3hgct9uai', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sr3z9o5it9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sr3z9o5it9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wai6z1evm9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wai6z1evm9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0xdwu76rzbf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xdwu76rzbf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pn4pq8yvpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pn4pq8yvpb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjkx62vxqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjkx62vxqd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ssffjr1w5"]=  window.__ectimmers["ecom-ssffjr1w5"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-ssffjr1w5"]["n4824suq7"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ssffjr1w5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ssffjr1w5', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e72dmlgygih"]=  window.__ectimmers["ecom-e72dmlgygih"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=($=this.settings.disable_auto_close__tablet)!=null?$:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function G(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-e72dmlgygih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e72dmlgygih', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}